import { render, staticRenderFns } from "./PodDetails.vue?vue&type=template&id=786c1f67&scoped=true&"
import script from "./PodDetails.vue?vue&type=script&lang=js&"
export * from "./PodDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786c1f67",
  null
  
)

export default component.exports